import { createBrowserRouter } from 'react-router-dom';
import { vitalspath, vitalspathv2 } from './utils/ApiConstants';
import loadable from '@loadable/component'
import BreatheFreeLiveTv from './breathefreelivetv/BreatheFreeLiveTv';

import { InhalerTraining } from './inhalerTraining/InhalerTraining';
import ChatBot from './chatbot';
import { PrivacyConsent } from './privacy-consent/PrivacyConsent';
const NotFound = loadable(() => import('./vitals-screens/404'));
const ScanInstructions = loadable(() => import('./vitals-screens/ScanInstructions'));
const SelectPosture = loadable(() => import('./vitals-screens/SelectPosture'));
const FaceScan = loadable(() => import('./vitals-screens/FaceScan'));
const FingerScan = loadable(() => import('./vitals-screens/FingerScan'));
const ScanResult = loadable(() => import('./vitals-screens/ScanResult'));
const LungCare = loadable(() => import('./lung-care-landing/LungCare'));
const PatientScreener = loadable(() => import('./care-oad-screener/PatientScreener'));
const EducatorLogin = loadable(() => import('./care-oad-screener/EducatorLogin'));
const EducatorEmployeeFetch = loadable(() => import('./care-oad-screener/EducatorEmployeeFetch'));
const SelectOption = loadable(() => import('./vitals-screens/SelectOption'));
const FaceScanV2 = loadable(() => import('./vitals-screens-v2/FaceScan'));
const FingerScanV2 = loadable(() => import('./vitals-screens-v2/FingerScan'));
const HowToScan = loadable(() => import('./vitals-screens-v2/howToScan'));
const PeakFlowMeter = loadable(() => import('./peak-flow-meter/PeakFlowMeter'));
const BotPressCtn = loadable(() => import('./BotPressCtn'));

export const router = createBrowserRouter([
  // { index: true, path: '/', element: <Navigate to={`${vitalspath}/select-option`} replace /> },
  { path: `${vitalspath}/select-option`, element: <SelectOption /> },
  { path: `/lung-care-landing1`, element: <LungCare  ctaToCall={"8657789425"} /> },
  { path: `/lung-care-landing2`, element: <LungCare ctaToWhatsapp={"918657789425"}  /> },
  { path: `/lung-care-landing`, element: <LungCare  /> },
  // { path: `/peak-flow-meter/:mobileno/:username/:emp_id/:secondary_uuid`, element: <PeakFlowMeter  /> },
  { path: `/peak-flow-meter`, element: <PeakFlowMeter  /> },
  {
    path: `${vitalspath}/scan-instructions/:authtoken/:scanType/:scanToken/:emp_id/:secondary_uuid/:dob/:gender/:height/:weight`,
    element: <ScanInstructions />,
  },
  { path: `${vitalspath}/select-posture`, element: <SelectPosture /> },
  { path: `${vitalspath}/scan-result`, element: <ScanResult /> },
  { path: `${vitalspath}/face-scan`, element: <FaceScan /> },
  { path: `${vitalspathv2}/face-scan`, element: <FaceScanV2 /> },
  { path: `${vitalspath}/finger-scan`, element: <FingerScan /> },
  { path: `${vitalspathv2}/finger-scan`, element: <FingerScanV2 /> },
  { path: `${vitalspathv2}/how-to-scan`, element: <HowToScan /> },

  { path: `/care-oad-screener`, element: <PatientScreener /> },
  { path: `/care-oad-screener/educator-login`, element: <EducatorLogin /> },
  { path: `/care-oad-screener/educator-employee-fetch`, element: <EducatorEmployeeFetch /> },
  { path: '/breathefree-live-tv', element: <BreatheFreeLiveTv /> },
  { path: '/botpress', element: <BotPressCtn /> },
  { path: '/inhaler-training', element: <InhalerTraining /> },
  { path: '/chatbot', element: <ChatBot /> },
  { path: '/privacy-consent', element: <PrivacyConsent /> },
  { path: '*', element: <NotFound /> },
]);
